import React from 'react';
import './TermsOfServiceComponent.css'; // Import CSS

const TermsOfServiceComponent = () => {
  return (
    <div className="terms-of-service-container">
      <h1>Terms of Service</h1>

      <p className="effective-date">
        <strong>Effective Date:</strong> March 15, 2026
      </p>

      <section className="terms-section">
        <h2>1. Acceptance of Terms</h2>
        <p>
          Welcome to Skhool's School ERP, Website Platform, and Mobile Application (collectively, the "Platform"). By accessing or using our Platform, whether as a school, staff member, student, parent, website visitor, or mobile app user, you ("User" or "you") agree to be bound by these Terms of Service ("Terms"). Please read these Terms carefully before using the Platform. If you do not agree to all of these Terms, you are expressly prohibited from using the Platform and must discontinue use immediately.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. Description of Service</h2>
        <p>
          The Platform provides a comprehensive suite of services for schools, including student information management, academic management, attendance, fee management, website hosting, communication tools, notifications, event management, transport tracking, and mobile application access for parents and employees. The Platform is designed to facilitate school administration and enhance communication within the school community.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. User Accounts and Registration</h2>
        <p>
          To access certain features of the Platform, you may be required to register for an account. You agree to:
        </p>
        <ul className="terms-list">
          <li>Provide accurate, current, and complete information during the registration process.</li>
          <li>Maintain the security of your password and account credentials.</li>
          <li>Be responsible for all activities that occur under your account.</li>
          <li>Notify us immediately of any unauthorized access or use of your account.</li>
        </ul>
        <p>
          School accounts are typically created and managed by authorized school administrators. Individual user accounts (staff, student, parent) are often linked to the school's account.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. Acceptable Use Policy</h2>
        <p>
          You agree to use the Platform in a responsible and lawful manner.  You must not:
        </p>
        <ul className="terms-list">
          <li>Use the Platform for any illegal purpose or in violation of any applicable laws or regulations.</li>
          <li>Upload, post, or transmit any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.</li>
          <li>Impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity.</li>
          <li>Interfere with or disrupt the operation of the Platform or the servers or networks used to make the Platform available.</li>
          <li>Attempt to gain unauthorized access to any portion of the Platform or any other accounts, systems, or networks connected to the Platform.</li>
          <li>Use any robot, spider, scraper, or other automated means to access the Platform for any purpose without our express written permission.</li>
          <li>Transmit or upload viruses, worms, or other malicious code.</li>
          <li>Engage in any activity that could damage, disable, overburden, or impair the Platform.</li>
          <li>Collect or store personal information about other users without their express consent.</li>
          <li>Violate any intellectual property rights, including copyright and trademark.</li>
          <li>Use the Platform to send unsolicited communications, promotions, advertisements, or spam.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. Content Ownership and User Content</h2>
        <p>
          The Platform and its original content, features, and functionality (including but not limited to text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software) are owned by Skhool and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
        </p>
        <p>
          **User Content:** Users may upload content to the Platform, including but not limited to website content, images, event information, and other materials ("User Content"). You retain ownership of your User Content. By uploading User Content to the Platform, you grant Skhool a non-exclusive, worldwide, royalty-free, transferable, sub-licensable license to use, reproduce, distribute, prepare derivative works of, display, and perform your User Content in connection with the operation of the Platform and our services.
        </p>
        <p>
          You represent and warrant that you have all necessary rights to grant the licenses in this Section and that your User Content does not violate these Terms or any applicable laws or regulations, including intellectual property rights and privacy rights.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. Intellectual Property Rights</h2>
        <p>
          The name "Skhool", the logo, and all related names, logos, product and service names, designs, and slogans are trademarks of Skhool or its affiliates or licensors. You must not use such marks without our prior written permission. All other names, logos, product and service names, designs, and slogans on this Platform are the trademarks of their respective owners.
        </p>
        <p>
          The Platform, including its software, databases, and content (excluding User Content), is protected by copyright and other intellectual property laws. You are granted a limited, non-exclusive, non-transferable, revocable license to access and use the Platform for its intended purpose, subject to these Terms.  You are not permitted to copy, modify, distribute, sell, or lease any part of our Platform or included software, nor may you reverse engineer or attempt to extract the source code of that software.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. Fees and Payments (if applicable)</h2>
        <p>
          [If your platform has fees, detail them here. If not, you can state: "Currently, access to the core features of our Platform is provided [free of charge/based on subscription plans - adjust as needed]. We reserve the right to introduce fees for certain features or services in the future. We will provide reasonable notice of any such changes." ]
        </p>
        <p>
          [If you have fees, include details about subscription plans, payment methods, billing cycles, renewal policies, taxes, refund policies, etc.  Example language:]
          Subscription fees for premium features are outlined on our pricing page [link to pricing page]. Payments are processed securely through our third-party payment processor [Name of processor].  Subscriptions are typically billed [monthly/annually] and will automatically renew unless cancelled prior to the renewal date.  [Detail refund policy if applicable].
        </p>
      </section>

      <section className="terms-section">
        <h2>8. Disclaimers and Limitation of Liability</h2>
        <p>
          THE PLATFORM IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. SKHOOL DOES NOT WARRANT THAT THE PLATFORM WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
        </p>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL SKHOOL, ITS AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, SUPPLIERS, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM (A) YOUR USE OF OR INABILITY TO USE THE PLATFORM; (B) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY PERSONAL INFORMATION STORED THEREIN; (C) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE PLATFORM; (D) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH OUR PLATFORM BY ANY THIRD PARTY; (E) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF YOUR USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE PLATFORM; AND/OR (F) USER CONTENT OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY.
        </p>
        <p>
          IN NO EVENT SHALL THE AGGREGATE LIABILITY OF SKHOOL, ITS AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, SUPPLIERS, OR LICENSORS, FOR ALL CLAIMS RELATING TO THE PLATFORM EXCEED THE AMOUNT PAID BY YOU, IF ANY, TO SKHOOL FOR THE PLATFORM IN THE TWELVE (12) MONTHS PRIOR TO THE EVENT GIVING RISE TO THE LIABILITY.
        </p>
        <p>
          [**IMPORTANT:**  The disclaimers and limitations of liability are very important legal clauses. **Have a lawyer review and customize these sections to ensure they are legally sound and enforceable in your jurisdiction.**]
        </p>
      </section>

      <section className="terms-section">
        <h2>9. Indemnification</h2>
        <p>
          You agree to indemnify, defend, and hold harmless Skhool, its affiliates, directors, officers, employees, agents, suppliers, and licensors from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to: (a) your use of the Platform; (b) your User Content; (c) your violation of these Terms; or (d) your violation of any rights of another party.
        </p>
      </section>

      <section className="terms-section">
        <h2>10. Termination</h2>
        <p>
          We may terminate or suspend your access to the Platform, in whole or in part, at any time, with or without cause, and with or without notice, effective immediately. Reasons for termination may include, but are not limited to: violation of these Terms, inactivity, suspected illegal activity, or for business reasons.
        </p>
        <p>
          Upon termination, your right to use the Platform will cease immediately.  [Detail what happens to User Content upon termination, if applicable and legally required]. Sections [mention sections that survive termination, e.g., Disclaimers, Limitation of Liability, Indemnification, Governing Law] of these Terms shall survive any termination.
        </p>
        <p>
          You may also terminate your account at any time by [describe account termination process, e.g., contacting support].
        </p>
      </section>

      <section className="terms-section">
        <h2>11. Governing Law and Dispute Resolution</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of laws principles.
        </p>
        <p>
          Any dispute arising out of or relating to these Terms or the Platform shall first be attempted to be resolved through good faith negotiation. If negotiation fails, disputes shall be resolved in the courts of Bengaluru, Karnataka, India.
        </p>
        <p>
          [**Legal Note:**  Choosing the governing law and dispute resolution method is a significant legal decision. **Consult with legal counsel to determine the most appropriate jurisdiction and dispute resolution process for your business.**]
        </p>
      </section>

      <section className="terms-section">
        <h2>12. Changes to These Terms</h2>
        <p>
          We reserve the right to modify or revise these Terms at any time. We will notify you of any material changes by posting the updated Terms on the Platform and/or through other reasonable means of communication (e.g., email notification).  Changes will be effective immediately upon posting or notification, unless otherwise stated.
        </p>
        <p>
          Your continued use of the Platform after the posting of revised Terms means that you accept and agree to the changes. You are expected to check this page periodically to take notice of any updates.
        </p>
      </section>

      <section className="terms-section contact-section">
        <h2>13. Contact Us</h2>
        <p>
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <address className="company-address">
          Skhool<br />
          <strong>Email:</strong> <a href="mailto:support@skhool.in">support@skhool.in</a><br />
          <strong>Phone:</strong> 100% support via email and in‑app helpdesk
        </address>
      </section>

      <p className="last-updated">
        Last updated: March 15, 2026
      </p>
    </div>
  );
};

export default TermsOfServiceComponent;
